import { Link } from "react-router-dom";
import { STUDIO_URL, SUPPORT_EMAIL } from "../lib/runtimeConfig.js";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col" style={{ maxWidth: "340px" }}>
            <div className="brand">
              <span className="brand-mark" aria-hidden="true">513</span>
              <span className="brand-word">Travel</span>
            </div>
            <p className="footer-tag">
              Africa-first travel planning for flights, stays, visas, tours and
              custom journeys across Africa and beyond.
            </p>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <Link to="/flights">Flights</Link>
            <Link to="/stays">Stays</Link>
            <Link to="/experiences">Experiences</Link>
            <Link to="/africa">Africa</Link>
          </div>

          <div className="footer-col">
            <h4>Plan</h4>
            <Link to="/plan-a-trip">Plan a Trip</Link>
            <Link to="/track-trip">Track Trip</Link>
            <Link to="/visas">Visas</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>More</h4>
            <a href={STUDIO_URL} target="_blank" rel="noopener noreferrer">
              513Travel Studio ↗
            </a>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} 513Travel. All rights reserved.</span>
          <span>Curated journeys • Africa &amp; beyond</span>
        </div>
      </div>
    </footer>
  );
}
